import { createFileRoute } from '@tanstack/react-router';

import { OnboardingChooser } from '@/features/profiles/onboarding-page';

export const Route = createFileRoute('/_app/onboarding/')({ component: OnboardingChooser });
